<template>
  <div class="problem-body">
    <el-row>
      <el-col :span="24">
        <div class="nb">
          <information-sidebar 
            :info-id="informationInfo.infoId"
            :other-list="informationInfo.otherList"
            @select="handleSelect"
          />
          
          <div class="problem-rside">
            <div class="probar">
              <a v-if="informationInfo.infoId" href="">资讯</a>
              <a v-else href="">帮助中心</a>
            </div>

            <div class="problemcon">
              <h3 class="title">{{ informationInfo.information.title }}</h3>
              <div class="pnr">
                <p style="box-sizing:border-box;margin-top:0px;margin-bottom:0px;padding:0px;line-height:23px;color:#333333;">
                  {{ informationInfo.information.content }}
                </p>
                <p><br /></p>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import InformationSidebar from '@/components/platform/information/InformationSidebar'
import { listInformation, listInformationOther } from '@/api/platform/informationApi'

export default {
  name: 'InformationView',
  components: {
    InformationSidebar
  },
  data() {
    return {
      informationInfo: {
        infoId: '',
        information: {},
        otherList: []
      }
    }
  },
  created() {
    this.informationInfo.infoId = this.$route.query.infoId || ''
    this.initData()
  },
  methods: {
    async initData() {
      if (this.informationInfo.infoId) {
        await this.getInformation()
      }
      await this.getInformationOther()
    },
    async getInformation() {
      try {
        const params = {
          row: 1,
          page: 1,
          infoId: this.informationInfo.infoId
        }
        const res = await listInformation(params)
        this.informationInfo.information = res.data[0]
      } catch (error) {
        console.error('获取资讯详情失败:', error)
      }
    },
    async getInformationOther() {
      try {
        const params = {
          row: 100,
          page: -1,
          isOther: 1
        }
        const res = await listInformationOther(params)
        this.informationInfo.otherList = res.data
      } catch (error) {
        console.error('获取其他资讯列表失败:', error)
      }
    },
    handleSelect(item) {
      this.informationInfo.information = item
    }
  }
}
</script>

<style scoped>
.problem-body {
  padding: 20px;
}
.nb {
  display: flex;
}
.problem-rside {
  flex: 1;
  padding-left: 20px;
}
.probar {
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}
.problemcon {
  padding: 20px 0;
}
.title {
  font-size: 18px;
  margin-bottom: 20px;
}
.pnr {
  line-height: 1.6;
}
</style>